function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.24803 16.5287C-0.27075 13.8981 0.630562 10.5343 3.26117 9.01556L14.1496 2.72911C16.5537 1.3411 19.5701 1.97437 21.231 4.10163C23.5318 3.46182 26.0612 4.42599 27.3105 6.58992C28.5582 8.75089 28.1314 11.4191 26.4327 13.0922C27.4884 15.6085 26.533 18.5769 24.1078 19.9772L13.2193 26.2636C10.5887 27.7824 7.22498 26.8811 5.70619 24.2505L1.24803 16.5287ZM23.8235 14.7973L21.3411 16.2305C18.7754 17.7118 15.4946 16.8328 14.0133 14.2671C12.532 11.7014 13.4111 8.42064 15.9768 6.93933L18.4362 5.51938C17.6571 4.91298 16.5573 4.80312 15.6496 5.32719L4.76117 11.6136C3.56544 12.304 3.15575 13.833 3.84611 15.0287L8.30427 22.7505C8.99462 23.9462 10.5236 24.3559 11.7193 23.6655L22.6078 17.3791C23.5379 16.8421 23.9924 15.7976 23.8235 14.7973ZM16.6114 12.7671C15.9585 11.6363 16.346 10.1903 17.4768 9.53741L21.4828 7.22453C22.6136 6.57165 24.0596 6.9591 24.7125 8.08992C25.3653 9.22073 24.9779 10.6667 23.8471 11.3196L19.8411 13.6325C18.7102 14.2853 17.2643 13.8979 16.6114 12.7671Z",
  fill: "#0C0030"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 19.472,
  cy: 11.151,
  rx: 1.71791,
  ry: 1.71809,
  transform: "rotate(-30 19.472 11.151)",
  fill: "#FBD4B9"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 28,
  height: 28,
  fill: "white"
})));

var SvgWallet = function SvgWallet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wallet.11bfe18d.svg";
export { ForwardRef as ReactComponent };